import React, { Component } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import { PostData } from "../../api/service";
import Gallery from 'react-grid-gallery';

class GalleryDescription extends Component {
  render() {
    return (
      <div>
        {this.props.type == "photo" ? (
          <SiteMap1 title={``} link="COLLEGE_PHOTO_GALLERY" />
        ) : null}
        {this.props.type == "document" ? (
          <SiteMap1
            title={`Document Gallery`}
            link="COLLEGE_DOWNLOADS_GALLERY"
          />
        ) : null}
        {this.props.type == "video" ? (
          <SiteMap2 title={`Video Gallery`} link="COLLEGE_VIDEO_GALLERY" />
        ) : null}
      </div>
    );
  }
}

export default GalleryDescription;

function SiteMap({ title }) {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    fetch(`/gallery/gallery.json`)
      .then((resp) => resp.json())
      .then((resp) => {
        setData(resp);
        setIsLoaded(true);
      });
  }, []);

  return (
    <div>
      <Typography
        variant="h5"
        gutterBottom
        style={{ color: "blue", fontWeight: 700 }}
      >
        {title}
      </Typography>

      <br />

      {isLoaded ? (
        <ImageGallery items={data} />
      ) : (
        <Typography>Loading . . . </Typography>
      )}
    </div>
  );
}

function SiteMap1({ title, link }) {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [year, setYear] = React.useState("ALL");
  const [years, setYears] = React.useState([]);
  const [images, setImages] = React.useState([]);

  function fetchList() {
    let d = {
      type: link,
      dept_code: "NSS",
    };

    if (link == "COLLEGE_PHOTO_GALLERY") {
      // PostData(`/getnoticesbytypedept`, d).then((resp) => {
        // fetch the college gallery
        PostData(`/getgallery`, {
          type: "COLLEGE",
          dept: "NSS",
        }).then((resp1) => {
          const formatted = resp1.map((el) => {
            const year = el.time_stamp.split("-")[2].split(" ")[0];
            return {
              ...el,
              title: el.caption,
              year: year,
            };
          });
    
          setData(formatted);
    
          // extract unique years
          const uniqueYears = [...new Set(formatted.map((d) => d.year))];
          setYears(uniqueYears);
    
          setIsLoaded(true);
        });
      // });
    } else {
      PostData(`/getnoticesbytypedept`, d).then((resp) => {
        // fetch the college gallery
        setData(resp);
        setIsLoaded(true);
      });
    }
  }

  React.useState(() => {
    fetchList();
  }, []);

  function showImages(upload_info) {
    let i = [];
    return (
      <Grid container spacing={2}>
        {upload_info.map((el, index) => (
          <Grid item xs={12} sm={12} md={3} lg={3} key={index}>
            {el.fileType === "image" && (
              <img alt="image" src={el.url} style={{ width: "100%",height:'200px', objectFit:"cover" }} />
            )}

            {el.fileType === "file" && (
              <a href={el.url} target="_blank">
                Download File
              </a>
            )}
          </Grid>
        ))}
      </Grid>
    );
  }


  const filteredData =
  year === "ALL" ? data : data.filter((d) => d.year === year);

  return (
    <div>
      <Typography
        variant="h5"
        gutterBottom
        style={{ color: "blue", fontWeight: 700 }}
      >
        {title}
      </Typography>

      <br />

      {isLoaded ? (
        <React.Fragment>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "25px" }}>
  
  <div
    onClick={() => setYear("ALL")}
    style={{
      padding: "8px 18px",
      border: "1px solid #1976d2",
      borderRadius: "20px",
      cursor: "pointer",
      fontWeight: 500,
      color: year === "ALL" ? "#fff" : "#1976d2",
      background: year === "ALL" ? "#1976d2" : "transparent",
      transition: "all 0.25s ease"
    }}
  >
    All
  </div>

  {years.map((y) => (
    <div
      key={y}
      onClick={() => setYear(y)}
      style={{
        padding: "8px 18px",
        border: "1px solid #1976d2",
        borderRadius: "20px",
        cursor: "pointer",
        fontWeight: 500,
        color: year === y ? "#fff" : "#1976d2",
        background: year === y ? "#1976d2" : "transparent",
        transition: "all 0.25s ease"
      }}
    >
      {y}
    </div>
  ))}

</div>
          <Grid container spacing={2}>
            {Array.isArray(filteredData) &&
              filteredData.map((el, index) => (
                <Grid item key={index} xs={12} sm={12} lg={12} md={12}>
                  <Typography variant="h6">{el.title}</Typography>
                  <Gallery  maxRows={10} style={{width: "100%", height: 800}} images={[...el.upload_info.map((el1) => ({
                                        src: el1.url,
                                        thumbnail: el1.url,
                                        width: 300,
                                        height: 450
                                    }))]} />
                  {/* <ImageGallery items={el.upload_info.map(im => ({
                    original: im.url,
                    thumbnail: im.url,
                  }))} /> */}

                  {/* {Array.isArray(el.upload_info)
                    ? showImages(el.upload_info)
                    : null} */}

                  <Divider />
                </Grid>
              ))}
          </Grid>
        </React.Fragment>
      ) : (
        <Typography>Loading . . . .</Typography>
      )}
    </div>
  );
}

function SiteMap2({ title, link }) {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  function fetchList() {
    let d = {
      type: link,
      dept_code: "NSS",
    };

    PostData(`/getnoticesbytypedept`, d).then((resp) => {
      setData(resp);
      setIsLoaded(true);
    });
  }

  React.useState(() => {
    fetchList();
  }, []);

  function showImages(upload_info) {
    let i = [];
    return (
      <Grid container spacing={2}>
        {upload_info.map((el, index) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
            {el.fileType === "image" && (
              <img alt="image" src={el.url} style={{ width: "100%" }} />
            )}

            {el.fileType === "file" && (
              <a href={el.url} target="_blank">
                Download File
              </a>
            )}
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <div>
      <Typography
        variant="h5"
        gutterBottom
        style={{ color: "blue", fontWeight: 700 }}
      >
        {title}
      </Typography>

      <br />

      {isLoaded ? (
        <React.Fragment>
          <Grid container spacing={2}>
            {Array.isArray(data) &&
              data.map((el, index) => (
                <Grid item key={index} xs={12} sm={12} lg={12} md={12}>
                  <Typography variant="h6">{el.title}</Typography>

                  <div
                    dangerouslySetInnerHTML={{ __html: el.description }}
                  ></div>

                  <Divider />
                </Grid>
              ))}
          </Grid>
        </React.Fragment>
      ) : (
        <Typography>Loading . . . .</Typography>
      )}
    </div>
  );
}
